'use client';

import { KeyboardStateProvider, useKeyboardState } from "./KeyboardStateContext";
import KeyboardTest from "./KeyboardTest";
import TestResultModal from "../components/TestResultModal";

function KeyboardToolInner() {
    const { resultModal, closeModal } = useKeyboardState();

    return (
        <>
            <KeyboardTest />
            <TestResultModal
                show={Boolean(resultModal)}
                title={resultModal?.title}
                status={resultModal?.status}
                body={resultModal?.body}
                onClose={closeModal}
            />
        </>
    );
}

export default function KeyboardToolClient() {
    return (
        <KeyboardStateProvider>
            <KeyboardToolInner />
        </KeyboardStateProvider>
    );
}
